<div class="header" *ngIf="title">
	<div class="icon" >
		<img src="assets/img/icons/icon-info-purple.svg" alt="info" />
	</div>
	<div class="info">
		<div class="title" [innerHtml]="title"></div>
		<div class="subtitle" [innerHtml]="subtitle"></div>
		<a
			*ngIf="factsheet"
			class="fact-sheet"
			[innerHtml]="factsheet.text"
			(click)="_goToLink(factsheet.url)"
		></a>
	</div>
	<!-- <div *ngIf="moreInfoLink" class="more-info">
		<a
			[innerHtml]="moreInfoLink.text"
			(click)="_goToLink(moreInfoLink.url)"></a>
	</div> -->
</div>
<div class="features">
	<ul *ngIf="features && features.length > 0">
		<li *ngFor="let feature of features">
			<img src="/assets/img/icons/icon-tick-orange.svg" alt="" />
			<span [innerHtml]="feature"></span>
		</li>
	</ul>
</div>
